import React, { useState, useEffect } from "react";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("profile");
  const [users, setUsers] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [newPassword, setNewPassword] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [savedAmount, setSavedAmount] = useState(null);
  const [lastUpdated, setLastUpdated] = useState("");

  const [orders, setOrders] = useState([]);

  const totalAmountReceived = Array.isArray(orders)
    ? orders.reduce((sum, o) => sum + parseFloat(o.amount), 0)
    : 0;

  useEffect(() => {
    if (activeTab === "users") {
      fetch("https://resumefuel.xyz/resume/src/backend/get_users.php")
        .then((res) => res.json())
        .then((data) => setUsers(data))
        .catch((err) => console.error("Failed to fetch users", err));
    }

    if (activeTab === "coupons") {
      fetch("https://resumefuel.xyz/resume/src/backend/get_coupons.php")
        .then((res) => res.json())
        .then((data) => setCoupons(data))
        .catch((err) => console.error("Failed to fetch coupons", err));
    }

    if (activeTab === "orders") {
      fetch("https://resumefuel.xyz/resume/src/backend/get_orders.php")
        .then((res) => res.json())
        .then((data) => {
          console.log("Fetched orders response:", data); // Optional debug
          if (Array.isArray(data.orders)) {
            setOrders(data.orders);
          } else {
            setOrders([]); // Fallback to empty array
          }
        })
        .catch((err) => {
          console.error("Failed to fetch orders", err);
          setOrders([]); // Ensure state is still valid
        });
    }


    if (activeTab === "payments") {
      fetch("https://resumefuel.xyz/resume/src/backend/get_paypal_amount.php")
        .then((res) => res.json())
        .then((data) => {
          if (data.amount !== undefined) {
            setPaymentAmount(data.amount.toString());
            setSavedAmount(data.amount.toString());
          }
          if (data.updated_at) {
            setLastUpdated(data.updated_at);
          }
        })
        .catch((err) => console.error("Failed to load PayPal amount", err));
    }
  }, [activeTab]);

  // ✅ Updated password change handler
  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword.trim().length < 6) {
      alert("Password must be at least 6 characters.");
      return;
    }

    try {
      const res = await fetch("https://resumefuel.xyz/resume/src/backend/update_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: newPassword }),
      });

      const data = await res.json();

      if (data.success) {
        alert("✅ Password updated successfully.");
        setNewPassword("");
      } else {
        alert(data.message || "Failed to update password.");
      }
    } catch (err) {
      console.error("Error updating password", err);
      alert("An error occurred while updating the password.");
    }
  };

  const handleLogout = () => {
    alert("Logged out successfully.");
    window.location.href = "/admin";
  };

  const handleAddCoupon = async (e) => {
    e.preventDefault();
    const code = couponCode.trim();
    const discount = parseInt(discountPercentage, 10);

    if (!code) {
      alert("Please enter a coupon code.");
      return;
    }
    if (isNaN(discount) || discount < 1 || discount > 100) {
      alert("Discount percentage must be a number between 1 and 100.");
      return;
    }

    try {
      const res = await fetch("https://resumefuel.xyz/resume/src/backend/add_coupon.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, discount_percentage: discount }),
      });
      const data = await res.json();
      if (data.success) {
        setCoupons([...coupons, { id: data.insertId || Date.now(), code, discount_percentage: discount }]);
        setCouponCode("");
        setDiscountPercentage("");
      } else {
        alert(data.message || "Error adding coupon");
      }
    } catch (err) {
      console.error("Error adding coupon", err);
    }
  };

  const handleDeleteCoupon = async (idx) => {
    const couponToDelete = coupons[idx];
    try {
      const res = await fetch("https://resumefuel.xyz/resume/src/backend/delete_coupon.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: couponToDelete.id }),
      });
      const data = await res.json();
      if (data.success) {
        const updated = [...coupons];
        updated.splice(idx, 1);
        setCoupons(updated);
      } else {
        alert(data.message || "Error deleting coupon");
      }
    } catch (err) {
      console.error("Error deleting coupon", err);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "users":
        return (
          <div>
            <h3>Registered Users</h3>
            <p><strong>Total Users:</strong> {users.length}</p>
          </div>
        );

      case "orders":
        return (
          <div>
            <h3>Order History</h3>
            <p><strong>Total Received:</strong> {totalAmountReceived}USD</p>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={cellStyle}>Order ID</th>
                  <th style={cellStyle}>Amount (USD)</th>
                  <th style={cellStyle}>Date</th>
                </tr>
              </thead>
              <tbody>
                {orders.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>No orders yet.</td>
                  </tr>
                ) : (
                  orders.map((o) => (
                    <tr key={o.id}>
                      <td style={cellStyle}>{o.order_id}</td>
                      <td style={cellStyle}>{o.amount}</td>
                      <td style={cellStyle}>{o.date}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        );

      case "payments":
        return (
          <div>
            <h3>Payment Methods</h3>
            <ul>
              <li>💳 PayPal – ✅ Active</li>
            </ul>
            <div style={{ marginTop: "20px" }}>
              <h4>Set PayPal Amount For Resume Purchase</h4>
              <form onSubmit={async (e) => {
                e.preventDefault();
                const amountValue = parseInt(paymentAmount, 10);
                if (isNaN(amountValue) || amountValue < 1) {
                  alert("Please enter a valid amount greater than 0.");
                  return;
                }

                try {
                  const res = await fetch("https://resumefuel.xyz/resume/src/backend/update_paypal_amount.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ amount: amountValue }),
                  });

                  const data = await res.json();
                  if (data.success) {
                    setSavedAmount(amountValue);
                    if (data.updated_at) {
                      setLastUpdated(data.updated_at);
                    }
                  } else {
                    alert(data.message || "Failed to update PayPal amount");
                  }
                } catch (err) {
                  console.error("Error updating PayPal amount", err);
                }
              }}>
                <input
                  type="number"
                  min="1"
                  value={paymentAmount}
                  onChange={(e) => setPaymentAmount(e.target.value)}
                  style={{ padding: "8px", width: "150px" }}
                />
                <button style={{ marginLeft: "10px", padding: "8px 16px" }}>Save</button>
              </form>
              {savedAmount && (
                <div style={{ marginTop: "10px", color: "green" }}>
                  ✅ {savedAmount} USD saved
                  {lastUpdated && (
                    <div style={{ fontSize: "0.9em", color: "#555" }}>
                      Last updated: {lastUpdated}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );

      case "coupons":
        return (
          <div>
            <h3>Manage Coupon Codes</h3>
            <form onSubmit={handleAddCoupon} style={{ marginBottom: "20px" }}>
              <input
                type="text"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                placeholder="New coupon code"
                style={{ padding: "8px", width: "150px", marginRight: "10px" }}
              />
              <input
                type="number"
                min="1"
                max="100"
                value={discountPercentage}
                onChange={(e) => setDiscountPercentage(e.target.value)}
                placeholder="Discount %"
                style={{ padding: "8px", width: "100px", marginRight: "10px" }}
              />
              <button style={{ padding: "8px 16px" }}>Add</button>
            </form>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={cellStyle}>Code</th>
                  <th style={cellStyle}>Discount %</th>
                  <th style={cellStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {coupons.length === 0 ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
                      No coupons added yet.
                    </td>
                  </tr>
                ) : (
                  coupons.map((coupon, idx) => (
                    <tr key={coupon.id || idx}>
                      <td style={cellStyle}>{coupon.code}</td>
                      <td style={cellStyle}>{coupon.discount_percentage}</td>
                      <td style={cellStyle}>
                        <button
                          onClick={() => handleDeleteCoupon(idx)}
                          style={btnStyle("#dc3545", "#fff")}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        );

      case "profile":
        return (
          <div>
            <h3>Admin Profile</h3>
            <form onSubmit={handlePasswordChange}>
              <label>Username:</label>
              <br />
              <input
                type="text"
                value="admin"
                disabled
                style={{ padding: "8px", width: "250px", marginBottom: "10px" }}
              />
              <br />
              <label>Change Password:</label>
              <br />
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="New password"
                style={{ padding: "8px", width: "250px" }}
              />
              <br />
              <button type="submit" style={{ marginTop: "10px", padding: "8px 16px" }}>
                Update Password
              </button>
            </form>
          </div>
        );

      default:
        return <p>Invalid tab</p>;
    }
  };

  const cellStyle = { border: "1px solid #ccc", padding: "8px" };
  const btnStyle = (bg, color) => ({
    padding: "4px 8px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: bg,
    color,
    cursor: "pointer",
  });

  const tabButtonStyle = (tab) => ({
    padding: "10px 20px",
    border: "1px solid #ccc",
    backgroundColor: activeTab === tab ? "#007bff" : "#f2f2f2",
    color: activeTab === tab ? "#fff" : "#000",
    cursor: "pointer",
    borderRadius: "4px",
    width: "100%",
    marginBottom: "10px",
  });

  return (
    <div style={{ padding: "40px", fontFamily: "Arial, sans-serif" }}>
      <h2>Admin Dashboard</h2>
      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ width: "20%" }}>
          <button style={tabButtonStyle("profile")} onClick={() => setActiveTab("profile")}>Profile</button>
          <button style={tabButtonStyle("users")} onClick={() => setActiveTab("users")}>Users</button>
          <button style={tabButtonStyle("orders")} onClick={() => setActiveTab("orders")}>Orders</button>
          <button style={tabButtonStyle("payments")} onClick={() => setActiveTab("payments")}>Payment Methods</button>
          <button style={tabButtonStyle("coupons")} onClick={() => setActiveTab("coupons")}>Coupon Codes</button>
          <button
            style={{ ...tabButtonStyle("logout"), backgroundColor: "#dc3545", color: "#fff" }}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
        <div style={{ flex: 1 }}>{renderTabContent()}</div>
      </div>
    </div>
  );
}

export default AdminDashboard;
